import { render } from "./App.vue?vue&type=template&id=27d3ba28"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=27d3ba28&lang=css"

import exportComponent from "/agent/_work/1/s/GiftCards/giftcard_vuejs_src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__